import { ApiResponse } from 'apisauce';
import { IResponseSnapshot } from 'src/models/response/Response';

import { IDynamicCode, IDynamicCodeSnapshot } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import { TGetDynamicCdResult, TUpdateDynamicCdResult } from './SystemSettingTypes';

/**
 * # SystemSetting Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new SystemSettingApi();
 *
 * ```
 */
export class SystemSettingApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getDynamicCdForSetting(dynamicCd?: number): Promise<TGetDynamicCdResult> {
    try {
      const url = `/v1/dynamic/code/item?dynamicCd=${dynamicCd}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const codes: IDynamicCode[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', codes, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async update(
    dynamicCode: number,
    dynamicCd: IDynamicCodeSnapshot[],
  ): Promise<TUpdateDynamicCdResult> {
    try {
      const url = `/v1/dynamic/code/${dynamicCode}/item`;
      const payload = dynamicCd;
      const response: ApiResponse<any> = await this.api.apisauce.put(url, payload);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const codes: IDynamicCode[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', codes, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
